import { Widget } from '@digital/ui';
import { Table } from 'antd';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { componentsSorting } from '../../../components/SortingTable';

import {
  Clausula,
  ClausulaPesquisa,
  getAllClausulaComItemAprovado,
  UpdateManyClausula,
} from '../../../api/minuta/Clausula';

interface TabelaOrdenacaoClausulasProps {
  atualizarTelaListaClausula: () => void;
}

const TabelaOrdenacaoClausulas: React.FC<TabelaOrdenacaoClausulasProps> = ({ atualizarTelaListaClausula }) => {
  const [clausulas, setClausulas] = useState<Clausula[]>([]);

  useEffect(() => {
    async function getClausulas() {
      await getAllClausulaComItemAprovado({} as ClausulaPesquisa).then(data => {
        if (data) {
          setClausulas(data);
        }
      });
    }
    getClausulas();
  }, []);

  const collums = [
    {
      title: 'Ordem',
      dataIndex: 'ordenacao',
      width: '5%',
    },
    {
      title: 'Descrição da clausula',
      dataIndex: 'descricao',
      width: '90%',
    },
  ];

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = clausulas[dragIndex];
      const respUpdate = update(clausulas, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      const ordem = respUpdate.map((ru, index) => {
        return { ...ru, ordenacao: index + 1 };
      });
      UpdateManyClausula({ clausulas: ordem }).then(() => {
        atualizarTelaListaClausula();
      });
      setClausulas(ordem);
    },
    [clausulas],
  );

  return (
    <Widget>
      <DndProvider backend={HTML5Backend}>
        <Table
          rowKey="id"
          dataSource={clausulas}
          columns={collums}
          components={componentsSorting}
          onRow={(record, index) => ({
            index,
            moveRow,
          })}
          pagination={false}
        />
      </DndProvider>
    </Widget>
  );
};

export default TabelaOrdenacaoClausulas;
